import {useMutation, useQuery} from "vue-query";
import http from "../http";
import {queryClient} from "../client";
import store from "../store";

export const currentUserQuery = () => useQuery('userCurrent', () => http.get('/api/user/current'))
export const updateCurrentUser = () => useMutation('userCurrent', (data) => http.post('/api/user', data), {
  onSuccess: (response) => {
    queryClient.setQueryData('userCurrent', response);
    store.commit('auth/SET_USER', response);
  }
})
export const getUserSources = () => useQuery('getUserSources', () => http.get('/api/user/get-user-sources'))
